import React from "react";
// Admin Imports
import Help from "views/admin/help";
import Profile from "views/admin/profile";
import CustomizeMessage from "views/admin/customizeMessage";
import Settings from "views/admin/settings";
import NFTMarketplace from "views/admin/marketplace";
import Vendor from "views/admin/vendor";
import ApplicableFlow from "views/admin/applicableFlow";
import ChatbotUsers from "views/admin/chatbotUsers";
import VendorOnboarding from "views/admin/vendorOnboarding";
import PendingApproval from "views/admin/pendingApproval";

// Auth Imports
import SignUp from "views/auth/SignUp";
import ForgotPassword from "views/auth/Forgotpassword";
import ResetPassword from "views/auth/Resetpassword";

// Icon Imports
import { MdHome, MdLock } from "react-icons/md";
import Login from "views/auth/Login";
import Organization from "views/auth/Organization";
import Language from "views/admin/language";

const routes = [
  {
    name: "Pending Approval",
    layout: "/admin",
    path: "pending-approval",
    component: <PendingApproval />,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    component: <Profile />,
  },
  {
    name: "Help",
    layout: "/admin",
    path: "help",
    component: <Help />,
  },
  {
    name: "Customize Message",
    layout: "/admin",
    path: "customize-message",
    component: <CustomizeMessage />,
  },
  {
    name: "Chatbot Users",
    layout: "/admin",
    path: "chatbot-users",
    component: <ChatbotUsers />,
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    component: <Settings />,
  },
  {
    name: "Vendor",
    layout: "/admin",
    path: "vendor",
    component: <Vendor />,
  },
  {
    name: "Vendor Onboarding",
    layout: "/admin",
    path: "vendor-onboarding",
    component: <VendorOnboarding />,
  },
  {
    name: "Applicable Flow",
    layout: "/admin",
    path: "applicable-flow",
    component: <ApplicableFlow />,
  },
  {
    name: "Languages",
    layout: "/admin",
    path: "languages",
    component: <Language />,
  },
  {
    name: "Dashboard",
    layout: "/admin",
    path: ":id", // Updated
    icon: <MdHome className="h-6 w-6" />,
    component: <NFTMarketplace />,
    secondary: true,
  },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  // },
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  // },
  {
    name: "Sign up",
    layout: "/auth",
    path: "sign-up",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignUp />,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    component: <ForgotPassword />,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "reset-password",
    component: <ResetPassword />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <Login />,
  },
  {
    name: "Organization",
    layout: "/auth",
    path: "organization",
    icon: <MdLock className="h-6 w-6" />,
    component: <Organization />,
  },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
];
export default routes;
